import { useState, useRef, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import socket from "../tools/socke";
import regresaBienFecha from "../tools/regresaBienFecha";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";


pdfMake.vfs = pdfFonts.vfs;

export default function Firmador({ datosPasados, cierro }) {
  const [file, setFile] = useState(null);
  const [usuarioSeleccionado, setUsuarioSolicitado] = useState(null);
  const dropRef = useRef();
  const token = "import.meta.env.VITE_APP_TOKEN";
// console.log(datosPasados)
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    if (!droppedFile || droppedFile.type !== "application/pdf") {
      Swal.fire("Archivo inválido", "Solo podés subir archivos PDF", "warning");
      return;
    }

    setFile(droppedFile);
  };

  const handleDragOver = (e) => e.preventDefault();
  function verificaFirmante(certificado, textoReferencia) {
    if (!certificado || typeof certificado !== "object") {
      return "fallo: certificado inválido";
    }

    if (!textoReferencia || typeof textoReferencia !== "string") {
      return "fallo: texto de referencia inválido";
    }


    const limpiar = (str) =>
      str
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    const ref = limpiar(textoReferencia);


    const regexApellido = /(?:\d+\s+)?([A-Za-zÁÉÍÓÚÑáéíóúñ]+)/;
    const match = limpiar(textoReferencia).match(regexApellido);

    if (!match) return "fallo: no se pudo extraer apellido";

    const apellidoBuscado = match[1];


    if (certificado.timbro) {
      const razon = limpiar(certificado.razon || "");
      if (razon.includes(apellidoBuscado)) return "correcto";
      return "fallo: el apellido no coincide con razon social (Detectado Timbo)";
    }

    if (certificado.marito) {
      const razon = limpiar(certificado.razon || "");
      const firmante = limpiar(certificado.firmante || "");
      if (razon.includes(apellidoBuscado) || firmante.includes(apellidoBuscado))
        return "correcto";
      return "fallo: el apellido no coincide (Detectado certificado)";
    }


    if (certificado.martinez) {
      const razon = limpiar(certificado.razon || "");
      const firmante = limpiar(certificado.firmante || "");
      if (razon.includes(apellidoBuscado) || firmante.includes(apellidoBuscado))
        return "correcto";
      return "fallo: el apellido no coincide (Detectado certificado)";
    }


    if (certificado.mi_certificado) {
      const subject = limpiar(certificado.subject_completo || "");
      if (subject.includes(apellidoBuscado)) return "correcto";
      return "fallo: el apellido no coincide con subject (mi certificado)";
    }


    return "fallo: no se identificó el tipo de firmante";
  }
  const subirArchivoFirmado = async (archivo) => {
    try {
      const usuario=ObtieneDatosCookies()
      const formData = new FormData();
      formData.append("archivo", archivo);
      formData.append("usuario", "SIGEDI: " + usuario.identificacion);

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/asignacion-materia/upload/${datosPasados.materiaAsignadaId
}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.mensaje == "Archivo subido correctamente") {
        socket.emit("acepteHoras", { dato: datosPasados.docenteDni })
        Swal.fire("Éxito", "Archivo enviado correctamente", "success");

        cierro()
      }

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo enviar el archivo", "error");
    }

  }
function verificaVisado(texto1, texto2) {
  const regex = /^(\d+)\s+([A-Za-zÁÉÍÓÚÑáéíóúñ]+(?:\s+[A-Za-zÁÉÍÓÚÑáéíóúñ]+)*)$/i;

  const match1 = texto1.trim().match(regex);
  const match2 = texto2.trim().match(regex);

  if (!match1) return "fallo: el primer texto no tiene formato válido";
  if (!match2) return "fallo: el segundo texto no tiene formato válido";

  const numero1 = match1[1];
  const apellido1 = match1[2].toLowerCase();
  const numero2 = match2[1];
  const apellido2 = match2[2].toLowerCase();

  if (numero1 !== numero2) return "fallo: los números no coinciden";
  if (apellido1 !== apellido2) return "fallo: los apellidos no coinciden";

  return "correcto";
}


  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
    
    } else {
      Swal.fire("Archivo inválido", "Solo podés subir archivos PDF", "warning");
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      Swal.fire("Falta el archivo", "Arrastrá un PDF antes de continuar", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    Swal.fire({
      title: "Procesando archivo...",
      text: "Por favor espere",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const res = await axios.post(
        "https://wwwp.isepsantafe.net.ar/verifica/verificar_pdf",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer sicapinyass`,
          },
        }
      );
if(res)
//         console.log(res)
      Swal.close();
      if (res.data.tiene_firmas) {
      
        if (res.data.total_firmas > 0) {
          if (res.data.firmas[0].mi_certificado) {
              const apellido = datosPasados.docente.split(",")[0].trim(); 
//               console.log(res.data.firmas[0].razon, datosPasados.materiaAsignadaId + " " + apellido)
//             console.log(verificaVisado(res.data.firmas[0].razon, datosPasados.materiaAsignadaId + " " + apellido))
         
            if (verificaVisado(res.data.firmas[0].razon, datosPasados.materiaAsignadaId + " " + apellido) == "correcto") {
//                           console.log(" visado correcto")
              if (res.data.total_firmas > 1 && res.data.total_firmas < 3) {

                
  subirArchivoFirmado(file);
} else {
  Swal.fire({
    icon: "warning",
    title: "Firmas no detectadas automáticamente",
    html: `
      <p>${verificaFirmante(res.data.firmas[1], apellido)}</p>
      <br/>
      <b>¿Desea continuar igualmente con la carga del archivo?</b>
      <br/>
      <small>
        Intente con el firmador de provincia o comuníquese con la división
        que le ofreció las horas.
      </small>
    `,
    showCancelButton: true,
    confirmButtonText: "Sí, continuar",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
    confirmButtonColor: "#d33",
  }).then((result) => {
    if (result.isConfirmed) {
      subirArchivoFirmado(file);
    }
  });
}



              } else {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "El archivo esta visado pero no lo firmo aun, recuerde que debe firmarlo antes de poder aceptarlo",
                });
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "El archivo esta visado pero no corresponde a la asignacion actual",
              })
            }


          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "EL formulario no posee correcto visado",
            });
          }
        }
       else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se encontraron firmas ni visado",
        });
      }



    } catch (error) {
      Swal.close();
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo procesar el archivo",
      });

    } finally {

      setFile(null);
    }
  }

  return (
    <>


      <div>
        <h3>SUBE LA DOCUMENTACION</h3>

        <div className="d-flex flex-column align-items-center p-4" style={{ maxWidth: "500px", margin: "0 auto" }}>


          <div
            ref={dropRef}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={() => document.getElementById("fileInput").click()}
            style={{
              width: "100%",
              height: "90px",
              border: "2px dashed #333",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              background: "#e6e5e5ff",
            }}
          >
            {!file ? (
              <p className="text-center m-0">
                <strong>Arrastrá aquí el archivo PDF Firmado</strong><br />
                o hacé clic para seleccionarlo
              </p>
            ) : (
              <p className="text-success fw-bold m-0">📄 {file.name}</p>
            )}
          </div>

          {/* Input oculto */}
          <input
            id="fileInput"
            type="file"
            accept="application/pdf"
            style={{ display: "none" }}
            onChange={handleFileSelect}
          />

          {/* Botón enviar */}
          <button
            onClick={handleSubmit}
            className="btn btn-dark mt-4"
            style={{ width: "100%" }}
            disabled={!file}
          >
            Subir Archivo FIRMADO
          </button>
        </div> <hr />
      </div>
    </>
  );
}
